document.addEventListener("DOMContentLoaded", () => {
  const dialogEl = document.querySelector(".exhibitors .exhibitors__dialog");
  const dialogCloseEl = dialogEl?.querySelector("button");
  const dialogContentEl = dialogEl?.querySelector("div");

  dialogCloseEl?.addEventListener("click", () => {
    dialogEl.close();
    document.body.style.overflow = null;
  });

  const handleCardClick = (el) => () => {
    if (!dialogContentEl) return null;
    dialogContentEl.innerHTML = el.outerHTML;
    dialogEl.showModal();
    document.body.style.overflow = "hidden";
  };

  document.querySelectorAll(".exhibitors .card--exhibitor")?.forEach((el) => {
    el?.addEventListener("click", handleCardClick(el));
  });

  document.querySelector("#results")?.addEventListener("update", () => {
    document.querySelectorAll(".exhibitors .card--exhibitor")?.forEach((el) => {
      el?.addEventListener("click", handleCardClick(el));
    });
  });
});
